// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1c0at","title":"InfoRow_title__1PHLA"};